// The per-user "last seen What's New post" setting, shared by every admin that mounts the What's New modal.
export enum WhatsNewAppSettingKeyEnum {
  WHATS_NEW_LAST_SEEN_BLOG = 'WHATS_NEW_LAST_SEEN_BLOG',
}
